export enum ReportType {
	UserBasicData = 0, // 用戶基本數據
	PracticeData = 1, // 練習數據
	TaskData = 2, // 任務數據
	UserLoginRecord = 3, // 用戶登入紀錄
	UserCompletePracticeRecord = 4, // 用戶完成練習紀錄
	Day21SurveyData = 5, // 21天問卷數據
	HealthIndexRecord = 6, // 330健康指數紀錄
	UserCollectionData = 7, // 用戶收藏數據
	UserDrawBoxRecord = 8, // 用戶抽取盲盒紀錄
	UserCompletePracticeTimerRecord = 9, // 用戶完成練習時計紀錄
	TreasureData = 10, // 寶物數據
	UserObtainTreasureRecord = 11, // 用戶獲得寶物紀錄
	UserPracticeData = 12, // 用戶練習數據
}
